import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';


const DownloadFiles24 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial24/tutorial24.zip?ref_type=heads&inline=false', download: 'tutorial24.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialTwentyFour= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>PyQt6 Tutorial: How To Make a Dynamic ListBox with Checkable Entries in QtDesigner</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/VfZFXY59MOc/maxresdefault.jpg"
                            alt="Tutorial 24"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    Welcome to another PyQt6 tutorial! In this video, we'll guide you through creating a dynamic ListBox with checkable entries using Qt Designer. PyQt6 is a powerful Python library for building graphical user interfaces, and in this tutorial, we’ll leverage its capabilities to create an interactive checklist that responds to user input.
                        <br /><strong>Key Topics Covered:</strong>
                        <ul>
                            <li>Setting up a PyQt6 project in Qt Designer</li>
                            <li>Adding checkable entries to a ListBox for interactive functionality</li>
                            <li>Designing a dynamic user interface with Qt Designer's intuitive tools</li>
                            <li>Writing Python code to handle CheckBox interactions</li>
                            <li>Creating a responsive application that updates based on user actions</li>
                        </ul>
                        Follow along with this tutorial and enhance your PyQt6 skills. Whether you're a beginner or an experienced developer, building dynamic user interfaces has never been easier. Don't forget to like, subscribe, and hit the bell icon to stay updated on our latest tutorials.

                        Let's dive into the world of PyQt6 and create an interactive ListBox with checkable entries together!
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #ListBox #CheckableEntries #GUI #InteractiveApp #PythonDevelopment
                    </p>

                    <button className="seemore">
                        <DownloadFiles24 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialTwentyFour;
